/* unplugin-vue-components disabled */import { render } from "./SettingsAuthItemSAML2.vue?vue&type=template&id=37840038&scoped=true&ts=true"
import script from "./SettingsAuthItemSAML2.vue?vue&type=script&lang=ts"
export * from "./SettingsAuthItemSAML2.vue?vue&type=script&lang=ts"

import "./SettingsAuthItemSAML2.vue?vue&type=style&index=0&id=37840038&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37840038"]])

export default __exports__